import React, { ReactNode } from 'react';
import { IconButton, Modal as MUIModal } from '@mui/material';
import { CloseIcon } from '../Icons/CloseIcon';

import Styles from './Modal.module.scss';

interface Props {
  setOpen: (value: boolean) => void;
  open: boolean;
  children: ReactNode;
}

const Modal = ({ setOpen, open, children }: Props) => {
  const handleClose = () => setOpen(false);

  return (
    <MUIModal open={open} onClose={handleClose} className="swell-event__modal">
      <div className={Styles.content}>
        <div className={Styles.contentWrapper}>
          <IconButton className={Styles.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
          {children}
        </div>
      </div>
    </MUIModal>
  );
};

export default Modal;
